<div class="grid grid-cols-2 gap-4">
  <mat-checkbox
    class="col-span-1"
    [disabled]="isLoading()"
    [(ngModel)]="fixedYAxisZeroPoint"
    (ngModelChange)="onFixedYAxisZeroPointChange()"
  >
    {{ 'RESULT.VISIBILITY_OPTIONS.FIXED_Y_AXIS_ZERO_POINT.TITLE' | translate }}
  </mat-checkbox>
</div>
